import React from 'react';
import PropTypes from 'prop-types';
import { FormProvider } from 'react-hook-form';

const Form = ({ methods, actions = {}, children }) => {
  const props = { ...methods, ...actions };
  return (
    <FormProvider {...props}>
      <form>{children}</form>
    </FormProvider>
  );
};

Form.defaultProps = {
  actions: {},
};

Form.propTypes = {
  children: PropTypes.any.isRequired,
  methods: PropTypes.object.isRequired,
  actions: PropTypes.object,
};

export default Form;
